import React from 'react'

export const CardItem = ({image, title, description}) => (
  <div className="card">
    <div className="card-body">
      <div className='about-card'>
        <img className='about-icon' src={image} ></img>
        <div className="about-card-title ms-3">{title}</div>
      </div>
      <p className="card-text mt-3">{description}</p>
    </div>
  </div>
)

export default CardItem
